module.exports = __webpack_public_path__ + "static/img/ic_bottom_home_off@2x.cb552a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_bottom_home_off@2x.png
// module id = w4Vi
// module chunks = 1